// Share/copy a link. Phones get the OS share sheet when available (Messages,
// AirDrop, group chats — where trades actually get argued about); everything
// else copies to the clipboard.
export function shareStrategy(nav, coarsePointer) {
  if (coarsePointer && nav && typeof nav.share === "function") return "share"
  return "copy"
}

export default {
  mounted() {
    this.el.addEventListener("click", () => {
      const url = this.el.dataset.url
      const track = (action) => {
        if (window.jitsu) {
          window.jitsu("track", "share.link_copied", {
            content_type: this.el.dataset.shareType || "unknown",
            share_id: this.el.dataset.shareId || "",
            action,
          })
        }
      }
      const coarse = window.matchMedia && window.matchMedia("(hover: none)").matches

      if (shareStrategy(navigator, coarse) === "share") {
        navigator.share({url}).then(() => track("shared")).catch(() => {})
        return
      }

      navigator.clipboard.writeText(url).then(() => {
        const orig = this.el.innerText
        this.el.innerText = "Copied!"
        setTimeout(() => { this.el.innerText = orig }, 2000)
        track("copied")
      })
    })
  }
}
